/* eslint indent: 0 */

import Backbone from 'backbone';
import isNil from 'lodash/isNil';
import forEach from 'lodash/forEach';
import union from 'lodash/union';
import map from 'lodash/map';

import MediaLibraryFolder from './media_library_folder.js';
  
const FoldersByAccount = Backbone.Collection.extend({
        
    url: '/v2/folders',
    
    model: MediaLibraryFolder,
    
    parse: function(response) {
      return response.data;
    },
    
    getSubtreeSortedByHierarchy: function(rootFolder){
      // recursively generate a list such that we sort this depth first
      var sorted = [rootFolder];
      var children = rootFolder.getChildren();
      if (children.length){
        for(var i = 0; i < children.length; i++){
          // append the sorted by hierarchy array of each of this nodes children
          Array.prototype.push.apply(sorted, children[i].collection.getSubtreeSortedByHierarchy(children[i]));
        }
      }
      return sorted;
    },
        
    getChildrenByFolder: function(parentFolder) {
      return this.filter(function(folder) {
        return folder.get('parent_id') == parentFolder.get('id') && !folder.isRoot();
      });
    },
    
    getRoot: function() {
      return this.findWhere({id: null});
    },

    getFolderOrRoot: function(obj) {
      var folder = Backbone.Collection.prototype.get.call(this, obj);
      return isNil(folder) ? this.getRoot() : folder;
    },

    get: function(obj) {
      if (isNil(obj)) {
        return this.getRoot();
      }
      return this.getFolderOrRoot(obj);
    },

    getDisallowedFolderIdsForUser: function({ userModel }) {
      /*
        For performance reasons, for now we hide assets in private folders
        on the front end.

        The goal is to omit any assets that belong to a private folder.

        What are those performance reasons?

        Since it is possible to search without a parent folder id specified,
        determining if an asset should be hidden requires figuring out, for each parent folder id,
        if that asset can be exposed in the search.
        
        The most performant way to do that is pulling every media library folder
        and figuring out what folder ids are disallowed using logic like
        `getDisallowedFolderIdsForUser`, but on the backend. (that's a bit of a project!)

        This would entail making a DB query for all media library folders on every ES request,
        which may be a bit heavy since we do so many es queries.
      */
      if (userModel.getPermissions().canViewPrivateMediaLibraryFolders()) {
        return [];
      }
      const uploadFoldersOwnedByOthers = this.filter((folder)=> {
        return (
          folder.get('special_folder_type') == 'uploads_subfolder' &&
          folder.get('special_external_id') != userModel.get('id')
        )
      });
      var forbiddenIds = [];
      forEach(uploadFoldersOwnedByOthers, (uploadFolder)=> {
        const uploadFolderAndChildren = uploadFolder.collection.getSubtreeSortedByHierarchy(uploadFolder);
        forbiddenIds = union(
          forbiddenIds, 
          map(uploadFolderAndChildren, (folderToExclude)=> {
            return folderToExclude.get('id');
          })
        );
      });
      return forbiddenIds;
    }

    
    
  });
   
export default FoldersByAccount;
